export default function Contact() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    // Validate textarea length
    const message = formData.get('message') as string;
    if (message && message.length > 500) {
      alert('Mesej melebihi 500 aksara. Sila pendekkan mesej anda.');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d4ej4hi3fj18bu6hivp0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });

      if (response.ok) {
        alert('Terima kasih! Mesej anda telah berjaya dihantar. Kami akan menghubungi anda tidak lama lagi.');
        form.reset();
      } else {
        alert('Maaf, terdapat masalah menghantar mesej. Sila cuba lagi.');
      }
    } catch (error) {
      alert('Maaf, terdapat masalah menghantar mesej. Sila cuba lagi.');
    }
  };

  return (
    <section id="hubungi" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Hubungi Kami</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Kami sedia membantu anda. Hubungi kami untuk sebarang pertanyaan
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-12">
          <div>
            <div className="bg-gradient-to-br from-emerald-700 to-emerald-900 rounded-2xl p-8 text-white mb-8">
              <h3 className="text-2xl font-bold mb-6">Maklumat Perhubungan</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Alamat</h4>
                    <p className="text-emerald-100">
                      Lot 3945, Kg Sagil Parit 1,<br />
                      84020 Tangkak,<br />
                      Johor Darul Takzim
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Telefon</h4>
                    <p className="text-emerald-100">+60 6-910 2805</p>
                    <p className="text-emerald-100">+60 19-733 4434 (WhatsApp)</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                    <i className="ri-mail-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Email</h4>
                    <p className="text-emerald-100">badankebajikanzawiyahjohor@gmail.com</p>
                    <p className="text-emerald-100">grakmadad@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                    <i className="ri-time-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">Waktu Operasi</h4>
                    <p className="text-emerald-100">Isnin - Jumaat: 8:00 AM - 5:00 PM</p>
                    <p className="text-emerald-100">Sabtu: 8:00 AM - 1:00 PM</p>
                    <p className="text-emerald-100">Ahad & Cuti Umum: Tutup</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/20">
                <h4 className="font-bold mb-4">Ikuti Kami</h4>
                <div className="flex gap-4">
                  <a href="https://www.facebook.com/DarulMadadOfficial7007/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-2xl"></i>
                  </a>
                  <button className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-2xl"></i>
                  </button>
                  <a href="https://www.youtube.com/@zawiyahdarulmadadsagil6299" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                    <i className="ri-youtube-fill text-2xl"></i>
                  </a>
                  <button className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                    <i className="ri-telegram-fill text-2xl"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-emerald-900 mb-6">Hantar Mesej</h3>
              
              <form className="space-y-6" data-readdy-form id="contact-form" onSubmit={handleSubmit}>
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Nama Penuh</label>
                  <input 
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600 text-sm"
                    placeholder="Masukkan nama penuh anda"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Email</label>
                  <input 
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600 text-sm"
                    placeholder="Masukkan email anda"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Nombor Telefon</label>
                  <input 
                    type="tel"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600 text-sm"
                    placeholder="Masukkan nombor telefon"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Subjek</label>
                  <select 
                    name="subject"
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600 text-sm appearance-none bg-white cursor-pointer"
                  >
                    <option value="">Pilih subjek</option>
                    <option value="kemasukan">Kemasukan Pelajar</option>
                    <option value="biasiswa">Biasiswa & Tajaan</option>
                    <option value="sumbangan">Sumbangan & Wakaf</option>
                    <option value="lawatan">Lawatan Madrasah</option>
                    <option value="lain">Lain-lain</option>
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 font-semibold mb-2">Mesej</label>
                  <textarea 
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600 resize-none text-sm"
                    placeholder="Tulis mesej anda di sini (maksimum 500 aksara)"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maksimum 500 aksara</p>
                </div>

                <button 
                  type="submit"
                  className="w-full bg-emerald-700 text-white py-4 rounded-full font-semibold hover:bg-emerald-800 transition-colors shadow-lg cursor-pointer whitespace-nowrap"
                >
                  Hantar Mesej
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-2xl h-96">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.5678!2d102.5789!3d2.2667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31d1f1f1f1f1f1f1%3A0xabcdef1234567890!2sLot%203945%2C%20Kampung%20Sagil%20Parit%201%2C%2084020%20Tangkak%2C%20Johor!5e0!3m2!1sms!2smy!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Lokasi Madrasah Tahfiz Al Quran Zawiyah Darul Madad di Tangkak Johor"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
